<template>
    <a v-else :href="link.href"
       :class="['button', 'search-panel__result-button button_theme_orange button_size_large', {'is-disabled': link.disabled}]">
        <span>{{ link.text }}</span>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 6C5.22386 6 5 5.77614 5 5.5C5 5.22386 5.22386 5 5.5 5H13.8333C14.1095 5 14.3333 5.22386 14.3333 5.5V13.8333C14.3333 14.1095 14.1095 14.3333 13.8333 14.3333C13.5572 14.3333 13.3333 14.1095 13.3333 13.8333V6.70711L5.85355 14.1869C5.65829 14.3821 5.34171 14.3821 5.14645 14.1869C4.95118 13.9916 4.95118 13.675 5.14645 13.4798L12.6262 6H5.5Z"/>
        </svg>
    </a>
</template>

<script>
export default {
    props: ['link']
};
</script>

<style lang="scss">
@import "ResultButton";
</style>
